export default __webpack_public_path__ + "static/media/court.19896b94.png";